import { BankAccount } from '../types'
import { PaymentsHttp } from '../http.ts'

export { resolvePaymentsAccessToken } from '../sso/services/payments-access.service'

const PREFIX = '/payments'
const headers = {
  'Content-type': 'application/json'
}

export const getBanksData = (accessToken?: string) => {
  return PaymentsHttp.get(`${PREFIX}/banks-data`, {
    headers: {
      ...headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    }
  })
}

export const getBankingPartnersData = (accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/banking-partners-data`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCountriesAllowedToOperateData = (accessToken?: string) => {
  return PaymentsHttp.get(`${PREFIX}/countries-allowed-to-operate-data`, {
    headers: {
      ...headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    }
  })
}

export const getPaymentsData = (queryToSearch: object, accessToken: string) => {
  return PaymentsHttp.post(
    `${PREFIX}/get-payments-data`,
    { ...queryToSearch },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const getBatchesData = (accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/batches-data`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getLastestBatchesByCompany = (customerCompanyId: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/lastest-batches/${customerCompanyId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getRequestedReportsByCompanyId = (customerCompanyId: string, country: string, accessToken?: string) => {
  return PaymentsHttp.get(`${PREFIX}/requested-reports/${customerCompanyId}/${country}`, {
    headers: {
      ...headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    }
  })
}

export const getPaymentDataById = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/payment-data/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCurrentPayments = (numberOfRegistriesLoaded: number, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/get-payments-from-adamo-pay-client/${numberOfRegistriesLoaded}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getPaymentTickets = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/payment-tickets/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

/* export const approvePayment = (customerDataToApproveId: string, payloadToSend: any, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-payment/${customerDataToApproveId}`,
    { ...payloadToSend },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
} */

export const approveBankAccountFinding = (customerDataToApproveId: string, payloadToSend: any, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-bank-account-finding/${customerDataToApproveId}`,
    { ...payloadToSend },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const updateRequestedReport = (reportId: string, payloadToSend: any, accessToken?: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/update-requested-report/${reportId}`,
    { ...payloadToSend },
    {
      headers: {
        ...headers,
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
      }
    }
  )
}

export const approveDuplicateReferenceFinding = (customerDataToApproveId: string, payloadToSend: any, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-duplicate-reference-finding/${customerDataToApproveId}`,
    { ...payloadToSend },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const rejectNoDocumentNumberFinding = (customerDataToApproveId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/reject-no-document-number-finding/${customerDataToApproveId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const rejectPaymentReferenceFinding = (customerDataToApproveId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/reject-payment-reference-finding/${customerDataToApproveId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const getAmountToBePaidByDocumentId = (documentId: string, currency: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/amount-to-be-paid/${documentId}/${currency}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCryptoWalletData = (accessToken: string, selectedNetwork: string) => {
  return PaymentsHttp.get(`${PREFIX}/crypto-wallet-data/${selectedNetwork}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendPaymentsToDisperse = (documentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/send-payments-to-disperse/${documentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const getCurrencyConversion = (accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/currency-conversion`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCurrentBanksBalances = (customerCompanyId: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/current-banks-balances/${customerCompanyId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const updateBankAssignedBalance = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/update-bank-assigned-balance`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const discardReviewedPayment = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/discard-reviewed-payment/${paymentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const sendReviewedPayment = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/send-reviewed-payment/${paymentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const sendPaymentDataToReview = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/send-payment-data-to-review`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const discardNoveltiesAndSendToDisperse = (documentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/discard-novelties-and-send-to-disperse/${documentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const rejectPaymentData = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/reject-payment/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const returnPaymentData = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/return-payment/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const approveBankAccountPaymentNovelty = (paymentId: string, bankAccountUpdatedData: BankAccount, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-bank-account-payment-novelty/${paymentId}`,
    { bankAccountUpdatedData },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const approvePaymentReferenceNovelty = (paymentId: string, paymentReferenceToSet: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-payment-reference-novelty/${paymentId}`,
    { paymentReferenceToSet },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const approvePaymentAmountNovelty = (paymentId: string, paymentAmountToSet: string | number, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/approve-payment-amount-novelty/${paymentId}`,
    { paymentAmountToSet },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const deletePaymentData = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/delete-payment/${paymentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const approveIdentificationDocumentNovelty = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/approve-identification-document-novelty/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const returnPaymentByPaymentsSpecialist = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/return-payment-by-payments-specialist/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const rejectPaymentByCompliance = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/reject-payment-by-compliance/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendReviewedPaymentByCompliance = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.put(
    `${PREFIX}/send-reviewed-payment-by-compliance/${paymentId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const approvePaymentByPaymentsSpecialist = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/approve-payment-by-payments-specialist/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const approveBackgroundResearchNovelty = (paymentId: string, payload: object, accessToken: string) => {
  return PaymentsHttp.put(`${PREFIX}/approve-background-research-novelty/${paymentId}`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const downloadPaymentVoucher = (paymentId: string, accessToken: string) => {
  return PaymentsHttp.get(`${PREFIX}/download-payment-voucher/${paymentId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const createAndDownloadPaymentsReportAsBatches = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/create-and-download-payments-report-as-batches`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const createAndDownloadPaymentsReport = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/create-and-download-payments-report`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const createAndDownloadFundingsReport = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/create-and-download-fundings-report`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendCryptoFunds = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/send-crypto-funds`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getCustomerCompanyPaymentsBySearch = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/customer-company-payments-by-search`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendPaymentComplianceRequest = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/send-payment-compliance-request`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendPaymentComplianceResponse = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/send-payment-compliance-response`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendPaymentComplianceComment = (payload: object, accessToken: string) => {
  return PaymentsHttp.post(`${PREFIX}/send-payment-compliance-comment`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendTransactionToReviewByCurrency = (payload: object, accessToken: string) => {
  return PaymentsHttp.post('/orchestrator/send-transaction-to-review-by-currency', payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const sendReviewedPaymentByCurrency = (paymentId: string, currency: string, accessToken: string) => {
  return PaymentsHttp.post(
    `/orchestrator/send-reviewed-payment-by-currency/${currency}`,
    { paymentId },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}
